import { api } from "@app/api/api";
import { SubscribeEndpointsEnum } from "@app/features/subscribe/constants/subscribe.endpoints";
import { SubscribeTypesInterface } from "@app/features/subscribe/types/subscribe.types";

export const subscribeToNewsletter = async (data: SubscribeTypesInterface) => {
  return api.post(SubscribeEndpointsEnum.SUBSCRIBE, data);
};
